class ProductBlock extends HTMLElement{
    constructor(){
        super();
    }
    connectedCallback(){
        let contentElement = this.querySelector('[data-block-content]');
        this.querySelector('[data-block-title]').addEventListener('click', function(){
            this.classList.toggle('open');
            contentElement.classList.toggle('hidden');
        });

        let links = this.querySelectorAll('.link-scroll');
        if(links.length){
            links.forEach( element => {
                element.addEventListener('click', (event) => {

                    event.preventDefault();

                    let id = element.getAttribute('href'),
                        selector = document.querySelector(id);

                    selector.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                });
            });
        }
    }

}
customElements.define('product-block', ProductBlock);
